export const TestIds = {
    bgOverlay: 'bgOverlay',
};
//# sourceMappingURL=constants.js.map